export default __webpack_public_path__ + "static/media/placeholder3@2x.538f1bb2.png";